import { useEffect } from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
import { setDiagnosticsConsent } from '../services/diagnostics';

export default function ConsentDiagnostics() {
  const { preferences } = useCookieConsent();
  useEffect(() => {
    setDiagnosticsConsent(preferences.diagnostics).catch(() => {});
    return () => { setDiagnosticsConsent(false); };
  }, [preferences.diagnostics]);
  return null;
}
